import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { LoanInfo } from "../../../models/customer.model";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
interface Props {
  loan: LoanInfo;
  handleDetail: Function;
}

const CustomerLoanCard = ({ loan, handleDetail }: Props) => {
  return (
    <Grid
      container
      sx={{ justifyContent: "start", alignItems: "center" }}
      spacing={2}
      columns={14}
    >
      <Grid
        item
        xs={14}
        sm={4}
        md={4}
        lg={3}
        xl={2}
        width={"100%"}
        height={"100%"}
      >
        <Box
          sx={{
            width: "120px",
            height: "120px",
            border: "1px solid #EDEFEF",
            borderRadius: "5px",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
            padding: "10px",
          }}
        >
          {loan?.financialSupplierLogoBase64 ? (
            <img
              alt={loan?.loanTemplateTitle}
              src={`data:image/png;base64,${loan?.financialSupplierLogoBase64}`}
              style={{ objectFit: "contain", width: "100%", height: "auto" }}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <AccountBalanceIcon sx={{ color: "#1D4A87", fontSize: "50px" }} />
            </Box>
          )}
        </Box>
      </Grid>
      <Grid item xs={14} sm={10} md={10} lg={11} xl={12}>
        <Grid
          container
          flexDirection={"column"}
          gap={"15px"}
          justifyContent={"center"}
          alignItems={"start"}
          width={"100%"}
        >
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "#1D4A87",
                display: "flex",
                alignItems: "center",
                gap: "7px",
              }}
            >
              {loan?.loanTemplateTitle}{" "}
              {loan?.organizationTitle && (
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    color: "#1D4A87",
                  }}
                >
                  - {loan?.organizationTitle}{" "}
                </span>
              )}
              <span
                style={{
                  backgroundColor:
                    loan?.loanRequestStatus === "Assigned" ||
                    loan?.loanRequestStatus === "Settled"
                      ? "#28A745"
                      : loan?.loanRequestStatus === "Rejected" ||
                        loan?.loanRequestStatus === "Canceled"
                      ? "#E6123D"
                      : "#FB8C00",
                  padding: "0.5rem",
                  color: "#fff",
                  borderRadius: "5px",
                  fontSize: "0.8rem",
                }}
              >
                {loan?.loanRequestStatusTitle}
              </span>
            </Typography>
            <Typography
              sx={{ fontSize: ".9rem", color: "#1D4A87", cursor: "pointer" }}
              onClick={() => handleDetail(loan?.referenceKey)}
            >
              <RemoveRedEyeOutlinedIcon
                sx={{ fontSize: "22px", marginLeft: "7px" }}
              />
              جزییات تسهیلات
            </Typography>
          </Grid>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {/* <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                flexShrink: 1,
              }}
            > */}
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                میزان تسهیلات:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.amount?.toLocaleString("fa")} ریال
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                تاریخ درخواست:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.requestDatePersian}
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                تاریخ اعطا:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.assignDatePersian}
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                تاریخ آخرین تغییر وضعیت:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.lastStatusChangeDatePersian}
                </span>
              </Typography>
              <Typography sx={{ width: "20%" }}></Typography>
            </Grid>
            {/* </Grid> */}
          </Grid>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {/* <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              flexShrink: 1,
            }}
          > */}
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                نوع بازپرداخت:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.repaymentTypeTitle}
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                طول دوره:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.durationByMonth} ماه
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                فاصله اقساط:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.stepSpaceByMonth} ماه
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  // , width: "20%"
                }}
              >
                مبلغ هر قسط:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {loan?.installmentAmount?.toLocaleString("fa")} ریال
                </span>
              </Typography>
            </Grid>
            {/* <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              مانده تسویه:{" "}
              <span style={{ fontWeight: "bold" }}>
                {loan?.remainingSettlement?.toLocaleString("fa")} ریال
              </span>
            </Typography> */}
            <Typography sx={{ width: "20%" }}></Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomerLoanCard;
